<template>
  <div class="buy-box-dashboard-page">
    <BuyBoxDashboard />
  </div>
</template>

<script>
import BuyBoxDashboard from './components/BuyBoxDashboard.vue'

export default {
  name: 'BuyBoxDashboardPage',
  components: {
    BuyBoxDashboard
  }
}
</script>

<style scoped>
.buy-box-dashboard-page {
  min-height: 100vh;
  background: #ffffff;
}
</style>




// WEBPACK FOOTER //
// BuyBoxDashboardPage.vue?73c8c0ab